import { DEFAULT_RUT_NUMERIC_PART, DEFAULT_RUT_VERIFIER } from '../default';
import { splitRut } from '../splitRut';

const formatRut = (fullRut: string): string => {
  const [rut, dv] = splitRut(fullRut);

  if (rut === DEFAULT_RUT_NUMERIC_PART && dv === DEFAULT_RUT_VERIFIER)
    return fullRut;

  const formattedRut = `${rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv}`;

  return formattedRut;
};

export { formatRut };
